import { Build } from '@stencil/core';

interface Labels {
  [id: string]: string;
}

function extractLabels() {
  if (Build.isBrowser || Build.isTesting) {
    return TYPO3.lang || {};
  } else if (Build.isServer) {
    return JSON.parse(document.querySelector('body').getAttribute('data-nlx-ssr-labels')) || {};
  }
  return {};
}

const labels: Labels = extractLabels();

export function translate(label: string, ...variables): string {
  let result = labels[label];
  if (!result) {
    return '{{' + label + '}}';
  }
  if (variables.length) {
    result = variables.reduce((curry: string, item: string) => {
      // TODO: Allow %s and %d to force strings and digits.
      return curry.replace(/%[sd]/, item);
    }, result);
  }
  return result;
}
class TranslationService {
  translate(label: string, ...variables) {
    return translate(label, ...variables);
  }
}

export const Translate = new TranslationService();
